import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingGrid() {
  const trendingArticles = articles.slice(0, 4);

  return (
    <section className="bg-foreground-950 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/20 text-background-50 text-xs font-label whitespace-nowrap">
              24h 热度榜
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mt-6 leading-tight">
              今日最炸<br />吃瓜猛料
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {trendingArticles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group block bg-background-100 rounded-lg overflow-hidden hover:bg-background-50 transition-colors cursor-pointer"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <span className="text-xs text-primary-500 font-label">
                    {article.category}
                  </span>
                  <h3 className="text-sm font-heading font-bold text-foreground-950 mt-1.5 line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs text-foreground-400">
                      {article.readCount > 100000
                        ? `${(article.readCount / 10000).toFixed(1)}万`
                        : article.readCount}{' '}
                      阅读
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}